<template>
    <div class="learning-coach-banner-container">
        <div class="learning-coach-banner -wrap">
            <div class="learning-coach-banner__left-container">
                <div class="learning-coach-banner__title-container">
                    <h2 class="learning-coach-banner__title">
                        <slot name="title"></slot>
                    </h2>
                </div>
                <p class="learning-coach-banner__description">
                    <slot name="description"></slot>
                </p>
            </div>
            <div class="learning-coach-banner__right-container">
                <div class="learning-coach-banner__portraits">
                    <img v-for="(image, index) in trainers.images" :key="index" :src="getImagePath(image)" alt="" class="learning-coach-banner__circular-portrait"/>
                </div>
                <div class="learning-coach-banner__buttons">
                    <div class="learning-coach-banner__link-buttons">
                       <slot name="buttons"></slot>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'learning-coach-banner',
        props: {
            trainers: Object
        },
        methods: {
            getImagePath (image) {
                return require(`@/assets/images/banners/${this.trainers.folder}/${image}`)
            },
            getIndex (index) {
                return +index
            }
        }
    }
</script>

<style lang="scss" scoped>
    .learning-coach-banner-container {
        margin: 30px 0px 30px 0;
    }

    .learning-coach-banner a {
        all: unset;
    }
    .learning-coach-banner {
        background: $old_lace;
        color: $black;
        border-radius: 10px;
        padding: 20px 30px;
        display: flex;

        [class*="mobile"] &, [class*="desktop_lg"] &, [class*="desktop_l"] & {
            flex-direction: column;
        }

        &__title {
            font-family: 'Quicksand-ExtraBold';

            [class*="mobile"] &, [class*="desktop_l"] & {
                font-size: 2.1rem;
            }
        }

        &__title-container {
            display: flex;
        }

        &__description {
            margin: 20px 0 0;
            font-family: 'Nunito-Regular';
            line-height: 24px;
            font-size: 1.7rem;

            [class*="mobile"] &, [class*="desktop_l"] & {
                margin: 20px 0 20px;
            }
        }

        &__right-container {
            flex-direction: row;
            display: flex;
            align-items: center;
            justify-content: center;

            [class*="mobile"] & {
                flex-direction: column;
            }
        }

        &__portraits {
            display: flex;
        }

        &__circular-portrait {
            margin: 0 5px;

            [class*="mobile"] &, [class*="desktop_l"] & {
                margin: 0 3px;
            }
        }

        &__left-container {
            flex-direction: column;
            display: flex;
            flex: 1;
            justify-content: center;
        }

        &__buttons {
            padding: 10px;
            margin: 0 0 0 15px;
            display: flex;
            line-height: 1;
            [class*="mobile"] &, [class*="desktop_l"] & {
                margin: 15px 0 0 15px;
            }
        }

        &__button {
            margin-bottom: 15px;
        }

        &__close-button {
            font-size: 3rem;
            margin: 0 20px;
            display: flex;
            align-items: center;
            [class*="mobile"] &, [class*="desktop_l"] & {
                margin: 0 8px;
            }
        }
    }
</style>
